export const ResponseState = {
	LOADING: "LOADING",
	ERROR: "ERROR",
	SUCCESS: "SUCCESS"
} as const;

export type ResponseStateType = keyof typeof ResponseState;

export type LoadingResponse = {
	state: typeof ResponseState.LOADING;
};

export type ErrorResponse = {
	state: typeof ResponseState.ERROR;
	error: string;
};

export type SuccessResponse<T> = {
	state: typeof ResponseState.SUCCESS;
	data: T;
};

export type FetchResponse<T> =
	| LoadingResponse
	| ErrorResponse
	| SuccessResponse<T>;

export function mergeState(
	...responses: FetchResponse<any>[]
): ResponseStateType {
	if (responses.some(response => response.state === ResponseState.ERROR)) {
		return ResponseState.ERROR;
	}
	if (responses.every(response => response.state === ResponseState.SUCCESS)) {
		return ResponseState.SUCCESS;
	}

	return ResponseState.LOADING;
}
